// src/utils/csrf.js
// چون احراز هویت حالا مبتنی بر کوکی httpOnly است، مرورگر کوکی را خودکار
// می‌فرستد؛ برای محافظت در برابر CSRF باید توکن csrftoken (که httpOnly نیست)
// را از کوکی بخوانیم و در هدر X-CSRFToken به بک‌اند بفرستیم.
export const getCsrfToken = () => {
  const match = document.cookie.match(/(?:^|;\s*)csrftoken=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : null;
};

export const authHeaders = (extra = {}) => {
  const csrfToken = getCsrfToken();
  return {
    'Content-Type': 'application/json',
    ...(csrfToken && { 'X-CSRFToken': csrfToken }),
    ...extra,
  };
};
